/* eslint-disable eqeqeq */
import React, { Fragment, createRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import CommonModalV2, { modalWidth } from "./commonModal/v2";
import ModalExitAlert from "./modalExitAlert";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import PPButton from '../subComponents/button';
import CMNTemplateForEversense, { CMNEversenseTemplateIdentifier } from "../cmnTemplate/Eversense";
import CMNTemplateForAxena, { CMNAxenaTemplateIdentifier } from "../cmnTemplate/Axena";
import CMNTemplateForDexcom, { CMNDexcomTemplateIdentifier } from "../cmnTemplate/Dexcom";
import CMNTemplateForApretude, { CMNApretudeTemplateIdentifier } from "../cmnTemplate/Apretude";
import CMNTemplateForVyepti, { CMNVyeptiTemplateIdentifier } from "../cmnTemplate/Vyepti";
import { ITEMPLATE } from '../../constants/cmnTemplateForEversense.constant';
import { ALTERNATE_RX_PRODUCT_VALUE } from '../../constants/product.constant';
import { generateEmailTemplateList, selectedProductIds, convertIntoEmail } from '../../utils/emailTemplates';
import { FEATURE } from '../../utils/feature';
import { ENV } from '../../utils/env';
import { generatePDF } from '@abhisek507/html2multipagepdf';
import {
  Letter,
  Quality as ImageQuality,
  RegularPageSelector as pageSelector,
  PageElementSelector as pageElementSelector,
  PageWithMaxPossibleWidthSelector as pageWithMaxPossibleWidthSelector,
} from '@abhisek507/html2multipagepdf/constants';
import { preparePDF } from '../../utils/referralForm';
import ApproveAndSendEmailStyle from "../../styles/approveAndSendEmailStyle";

const SubmitButtonRef = createRef();
const hasFeature = FEATURE();
const env = ENV();

const getModalMinHeight = () => window.innerHeight - 16;
const getModalWidth = () => {
    const standardWidth = modalWidth.xl;
    if (window.innerWidth > standardWidth) {
        return standardWidth;
    }
    return window.innerWidth - 16;
};

const Eversesnse = 'Eversense';
const Axena = 'Axena';
const Dexcom = 'Dexcom';
const Apretude = 'Apretude';
const Vyepti = 'Vyepti';

const ProvidersAndCreatePDFTemplateMap = new Map([
    [Eversesnse, ITEMPLATE({
        Template: CMNTemplateForEversense,
        id: CMNEversenseTemplateIdentifier,
        fileName: CMNEversenseTemplateIdentifier,
        preparePDF,
        enabled: true,
        requiredFields: [],
        hasPIDDependency: true,
        pageOptions: Letter,
        imageQuality: ImageQuality[env.CMN_PDF_QUALITY],
    })],
    [Axena, ITEMPLATE({
        Template: CMNTemplateForAxena,
        id: CMNAxenaTemplateIdentifier,
        fileName: CMNAxenaTemplateIdentifier,
        preparePDF,
        enabled: hasFeature.SHOW_CMN_FOR_AXENA,
        requiredFields: [],
        hasPIDDependency: false,
        pageOptions: Letter,
        imageQuality: ImageQuality[env.CMN_PDF_QUALITY],
    })],
    [Dexcom, ITEMPLATE({
        Template: CMNTemplateForDexcom,
        id: CMNDexcomTemplateIdentifier,
        fileName: CMNDexcomTemplateIdentifier,
        preparePDF,
        enabled: hasFeature.SHOW_CMN_FOR_DEXCOM,
        requiredFields: [],
        hasPIDDependency: true,
        pageOptions: Letter,
        imageQuality: ImageQuality[env.CMN_PDF_QUALITY],
    })],
    [Apretude, ITEMPLATE({
        Template: CMNTemplateForApretude,
        id: CMNApretudeTemplateIdentifier,
        fileName: CMNApretudeTemplateIdentifier,
        preparePDF,
        enabled: hasFeature.SHOW_CMN_FOR_APRETUDE,
        requiredFields: [],
        hasPIDDependency: true,
        pageOptions: Letter,
        imageQuality: ImageQuality[env.CMN_PDF_QUALITY],
    })],
    [Vyepti, ITEMPLATE({
        Template: CMNTemplateForVyepti,
        id: CMNVyeptiTemplateIdentifier,
        fileName: CMNVyeptiTemplateIdentifier,
        preparePDF,
        enabled: hasFeature.SHOW_CMN_FOR_VYEPTI,
        requiredFields: [],
        hasPIDDependency: true,
        pageOptions: Letter,
        imageQuality: ImageQuality[env.CMN_PDF_QUALITY],
    })],
]);

class ApproveAndSendEmail extends React.Component {
    state = {
        subjectLineError: false,
        emailMessageError: false,
        exitModalOpen: false,
        kitError: [],
        approveAndMailPinError: false,
        approvalOrderFlagError: [],
        approvalPrescriberFlagError: [],
        isChangeMade: false,
        pdfGenerationInProgress: false,
    }

    componentDidMount() {
        const {
            productInfo = {},
            selectedCardData = {},

            GetEmailTemplateFromSalesforce = async () => {},
            GetEmailTemplate = async () => {},
            SetDenialAndSendValue = () => {},
            GetApproveAndEmailPrepInfo = async () => {},
            GetOrderAndPrescriberFlags = async () => {},
        } = this.props;

        const DoctorID = selectedCardData.DoctorId;
        const { Product = [], StoreFrontData, productIds, OrderId = '' } = productInfo;
        let productString = "", productStringArray = [];

        for (let i = 0; i < Product.length; i++) {
            if ((Product[i].checked || Product.length === 1) && !Product[i].IsLabProduct) {
                productStringArray.push(`productIds=${Product[i].ProductId}`)
            }
        }
        for (let i = 0; i < productStringArray.length; i++) {
            if (i == 0) {
                productString += `?${productStringArray[i]}`
            } else {
                productString += `&${productStringArray[i]}`
            }
        }

        GetEmailTemplate({ DoctorID, OrderId });
        GetEmailTemplateFromSalesforce({
            productIds,
            storefrontId: StoreFrontData.StorefrontId,
            action: 'Approve',
            orderId: OrderId
        });

        GetApproveAndEmailPrepInfo && GetApproveAndEmailPrepInfo({ DoctorID, PaitentId: selectedCardData.UserId, OrderId: productInfo.OrderId, productString })
        GetOrderAndPrescriberFlags && GetOrderAndPrescriberFlags({ OrderId: productInfo.OrderId, productString })
        const { StoreFrontURL = "" } = productInfo;
        const subjectDefaultValue = `${StoreFrontURL}; Order #${OrderId}`
        SetDenialAndSendValue && SetDenialAndSendValue({ name: "subjectLine", value: subjectDefaultValue });
    }

    UNSAFE_componentWillUnmount() {
        let { ResetApproveAndMailData } = this.props;
        ResetApproveAndMailData && ResetApproveAndMailData();
    }

    componentDidUpdate(prevProps) {
        if (this.state.emailMessageError && this.props.emailMessage && this.props.emailMessage.trim()) {
            this.setState({ emailMessageError: false });
        }
        if (this.state.subjectLineError && this.props.subjectLine && this.props.subjectLine.trim()) {
            this.setState({ subjectLineError: false });
        }
        if (!this.state.approveAndMailPinError && this.props.approvalPinError && !this.props.approveAndMailPin) {
            this.setState({ approveAndMailPinError: true });
        }
    }

    openAlertModal = () => {
        const {
            closeOpenDenyAndEmail = () => {},
            action = {
                addDosespotPatientPrescription: () => {},
                resetDoseSpot: () => {},
            },
            selectedCardData = {},
        } = this.props;

        const { isChangeMade } = this.state;
        const { DoctorId, OrderId } = selectedCardData;

        // save the prescription data in db
        if (OrderId && DoctorId) {
            action.addDosespotPatientPrescription({
                OrderId: `${OrderId}`,
                DoctorId: `${DoctorId}`,
            });
        }

        if (!isChangeMade) {
            action.resetDoseSpot();
            closeOpenDenyAndEmail();
        } else {
            this.setState({ exitModalOpen: true });
        }
    }

    closeAlertModal = () => {
        this.setState({ exitModalOpen: false });
    }

    onConfirmation = () => {
        const {
            closeOpenDenyAndEmail,
            ResetApproveAndMailData,
            action = {
                resetDoseSpot: () => {},
            },
        } = this.props;
        action.resetDoseSpot();
        this.setState({ exitModalOpen: false });
        closeOpenDenyAndEmail && closeOpenDenyAndEmail();
        ResetApproveAndMailData && ResetApproveAndMailData();
    }

    onDailySupplyChange = (e, index) => {
        let { approveAndMailData = [], SetApproveAndMailData } = this.props;
        let { name, value } = e.target;
        value = value && parseInt(value);
        if ((typeof value === "number" && !isNaN(value)) || value === "") {
            if (!this.state.isChangeMade && value !== approveAndMailData[index][name]) {
                this.setState({ isChangeMade: true })
            }
            approveAndMailData[index][name] = value;
            approveAndMailData[index] = { ...approveAndMailData[index] };
            approveAndMailData = [...approveAndMailData];
            SetApproveAndMailData && SetApproveAndMailData(approveAndMailData);
        }
    }
    onChange = (e, index) => {
        let { approveAndMailData = [], SetApproveAndMailData } = this.props;
        let { name, value } = e.target;
        let errorName = name + "Error";
        let { kitError } = this.state;
        if (!this.state.isChangeMade) {
            this.setState({ isChangeMade: true })
        }
        if (value && value.trim()) {
            if (kitError[index]) {
                kitError[index][errorName] = false;
            }
            this.setState({ kitError });
        }
        approveAndMailData[index][name] = value;
        approveAndMailData[index] = { ...approveAndMailData[index] };
        approveAndMailData = [...approveAndMailData];
        SetApproveAndMailData && SetApproveAndMailData(approveAndMailData);
    }

    onDefaultOptionChange = (e, index) => {
        let { approveAndMailData = [], SetApproveAndMailData } = this.props;
        let { name, value } = e.target;
        if (!this.state.isChangeMade && value !== approveAndMailData[index].Refills[name]) {
            this.setState({ isChangeMade: true })
        }
        approveAndMailData[index].Refills[name] = value;
        approveAndMailData[index] = { ...approveAndMailData[index] };
        approveAndMailData = [...approveAndMailData];
        SetApproveAndMailData && SetApproveAndMailData(approveAndMailData);
    }

    onBlur = (e, index) => {
        let { name, value } = e.target;
        let errorName = name + "Error"
        value = value.trim();
        let { kitError } = this.state;
        kitError = [...kitError];
        if (value === "") {
            if (kitError[index]) {
                kitError[index][errorName] = true;
            } else {
                kitError[index] = {};
                kitError[index][errorName] = true;
            }
            this.setState({ kitError });
        } else if (kitError[index] && kitError[index][errorName]) {
            kitError[index][errorName] = false;
            this.setState({ kitError });
        }
    }

    onPinBlur = (e, index) => {
        let { name, value } = e.target;
        value += "";
        let errorName = name + "Error"
        value = value.trim();
        if (value === "" || value.length < 4) {
            this.setState({ [errorName]: true });
        } else if (this.state[errorName]) {
            this.setState({ [errorName]: false });
        }
    }

    getPrescriberInfo = (data) => {
        let { classes } = this.props, valueToReturn = [];
        for (let i = 0; i < data.length; i++) {
            let { Refills: { DefaultOption, IsEditable, RefillOptions }, IsAlternateRx } = data[i];
            if (!IsEditable) {
                RefillOptions = [DefaultOption];
            }
            valueToReturn.push(
                <div key={data[i].ProductId + i} className={!IsAlternateRx ? classes.wrapper : classes.AlternateRxWrapper}>
                    {!IsAlternateRx ? <div className={classes.contentWrapper}>
                        <div id="approve-and-email-pharmacy" className={classes.titleText}>
                            PHARMACY:
                        </div>
                        <div title={data[i].Patient} className={classes.pharmacyText}>
                            <span id="approve-and-email-pharmacy-text" className={classes.pharmacyTextSpan}>{data[i].Pharmacy}</span>
                        </div>
                    </div> : null}
                    {!IsAlternateRx ? <div className={classes.contentWrapper}>
                        <div id="approve-and-email-patient" className={classes.titleText}>
                            PATIENT:
                        </div>
                        <div title={data[i].Patient} className={classes.pharmacyText}>
                            <span id="approve-and-email-patient-text" className={classes.pharmacyTextSpan}>{data[i].Patient}</span>
                        </div>
                    </div> : null}
                    {!IsAlternateRx ? <div className={classes.contentWrapper}>
                        <div id="approve-and-email-prescriber" className={classes.titleText}>
                            PRESCRIBER:
                        </div>
                        <div title={data[i].Prescriber} className={classes.pharmacyText}>
                            <span id="approve-and-email-prescriber-text" className={classes.pharmacyTextSpan}>{data[i].Prescriber}</span>
                        </div>
                    </div> : null}
                    <div className={classes.contentWrapper}>
                        <div id="approve-and-email-prescribed" className={classes.titleText}>
                            PRESCRIBED:
                        </div>
                        <div title={data[i].Prescribed} className={classes.pharmacyText}>
                            <span id="approve-and-email-prescribed-text" className={classes.pharmacyTextSpan}>{data[i].Prescribed}</span>
                        </div>
                    </div>
                    {
                        !IsAlternateRx && (
                            <div className={classes.qtyContentWrapper}>
                                <div className={classes.flex}>
                                    <div className={classes.qtyItemWrapper}>
                                        <div id="approve-and-email-quantity" className={`${classes.titleText} no-margin`}>QUANTITY:</div>
                                        <div id="approve-and-email-quantity-text" title={data[i].Qty} className={classes.contentText}>
                                            {data[i].Qty}
                                        </div>
                                    </div>

                                    <div className={classes.qtyItemWrapper}>
                                        <div id="approve-and-email-days-supply" className={`${classes.titleText} no-margin`}>DAYS SUPPLY:</div>
                                        <input
                                            id="DaysSupply"
                                            name="DaysSupply"
                                            onBlur={_ => this.onBlur(_, i)}
                                            onChange={_ => this.onDailySupplyChange(_, i)}
                                            type="text"
                                            maxLength={3}
                                            className={`${classes.daysSupplyText} ${(this.state.kitError[i] && this.state.kitError[i].DaysSupplyError) ? classes.errorTextField : null}`}
                                            value={data[i].DaysSupply}
                                        />
                                    </div>

                                    <div className={classes.qtyItemWrapper}>
                                        <div id="approve-and-email-total-pills" className={`${classes.titleText} no-margin`}>TOTAL PILLS:</div>
                                        <div id="approve-and-email-total-pills-text" title={data[i].Qty} className={classes.contentText}>
                                            {data[i].TotalPills}
                                        </div>
                                    </div>
                                </div>

                                <div className={classes.flex}>
                                    <div className={classes.qtyItemWrapper}>
                                        <div id="approve-and-email-total-refills" className={`${classes.titleText} no-margin`}>REFILLS:</div>
                                        <FormControl variant="outlined" className={`${classes.productInput} ${!IsEditable ? classes.disabledSelect : ""}`}>
                                            <Select
                                                labelId="customized-select-label"
                                                id="selectedProduct"
                                                MenuProps={{ classes: { paper: classes.menuItemWidth, list: classes.menuItemList } }}
                                                classes={{ outlined: classes.productSelectStyle }}
                                                disabled={!IsEditable}
                                                value={DefaultOption}
                                                name="DefaultOption"
                                                onChange={_ => this.onDefaultOptionChange(_, i)}
                                                label={void 0}
                                            >
                                                {RefillOptions && RefillOptions.map((_, index) => {
                                                    return <MenuItem title={_} classes={{ selected: classes.menuItemSelected }} className={classes.menuItemRoot} key={index + _} value={_}>{_}</MenuItem>
                                                })}
                                            </Select>
                                        </FormControl>
                                    </div>

                                    <div className={classes.qtyItemWrapper}>
                                        <div id="approve-and-email-exp" className={`${classes.expText} no-margin`}>EXP:</div>
                                        <div id="approve-and-email-exp-text" title={data[i].Qty} className={classes.Expiry}>
                                            {data[i].TotalPills}
                                        </div>
                                    </div>

                                    <div className={classes.qtyItemWrapper}>
                                        <div id="approve-and-email-daily-supply-text" className={`${classes.subAllowedText} no-margin`}>{data[i].SubstitutionAllowed}</div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    {!IsAlternateRx ? <div className={classes.contentWrapper}>
                        <div id="approve-and-email-sig" className={classes.titleText}>
                            SIG:
                        </div>
                        <input
                            id="Sig"
                            name="Sig"
                            onBlur={_ => this.onBlur(_, i)}
                            onChange={_ => this.onChange(_, i)}
                            maxLength={140}
                            type="text"
                            className={`${classes.sigTextInput} ${(this.state.kitError[i] && this.state.kitError[i].SigError) ? classes.errorTextField : ""}`}
                            value={data[i].Sig}
                        />
                    </div> : null}
                    <div className={classes.contentWrapper}>
                        <div id="approve-and-email-note-prefix" className={classes.titleText}>
                            NOTE PREFIX:
                        </div>
                        <div title={data[i].NotePrefix} className={classes.pharmacyText}>
                            <span id="approve-and-email-note-prefix-text" className={classes.pharmacyTextSpan}>{data[i].NotePrefix}</span>
                        </div>
                    </div>
                    <div className={classes.noteContentWrapper}>
                        <div id="approve-and-email-note" className={classes.titleText}>
                            NOTE:
                        </div>
                        <textarea
                            id="prescriber_info_note"
                            name="Note"
                            onBlur={_ => this.onBlur(_, i)}
                            onChange={_ => this.onChange(_, i)}
                            maxLength={180}
                            type="text"
                            className={`${classes.NoteTextArea} ${(this.state.kitError[i] && this.state.kitError[i].NoteError) ? classes.errorTextField : ""}`}
                            value={data[i].Note}
                        />
                    </div>
                </div>
            )
        }
        return valueToReturn;
    }

    handleEmailTemplateChange = (e) => {
        const {
            SetDenialAndSendValue = async () => {},
            GetSubjectAndMailFromSalesforce = async () => {},
            GetSubjectAndMail = async () => {},
            emailTemplateValue = -1,
            selectedCardData = {},
            productInfo = {},
        } = this.props;
        const value = parseInt(e.target.value);
        if (!this.state.isChangeMade && value !== emailTemplateValue) {
            this.setState({ isChangeMade: true })
        }
        SetDenialAndSendValue({ name: "emailTemplateValue", value });

        switch (`${hasFeature.PULL_EMAIL_TEMPLATES_FROM_SALESFORCE}`) {
            case 'true': {
                GetSubjectAndMailFromSalesforce({ messageId: value });
                break;
            }
            case 'false': {
                if (value !== -1) {
                    GetSubjectAndMail({ DoctorId: selectedCardData.DoctorId, OrderId: productInfo.OrderId }, value);
                }
                break;
            }
            default: {
                break;
            }
        }
    }

    handleInputLineBlur = (e) => {
        let { value, name } = e.target;
        value = value.trim();
        name = name + "Error"
        if (value === "") {
            this.setState({ [name]: true })
        } else if (this.state[name]) {
            this.setState({ [name]: false })
        }
    }

    handleInputLineChange = (e) => {
        let { SetDenialAndSendValue } = this.props;
        let { name, value } = e.target;
        if (!this.state.isChangeMade) {
            this.setState({ isChangeMade: true })
        }
        SetDenialAndSendValue && SetDenialAndSendValue({ name, value })
    }

    onValueChange = (e) => {
        let { HandleGlobalValueChange } = this.props;
        let { name, value } = e.target;
        value = value !== "" ? parseInt(value) : "";
        if ((typeof value === "number" && !isNaN(value)) || value === "") {
            if (!this.state.isChangeMade) {
                this.setState({ isChangeMade: true })
            }
            HandleGlobalValueChange && HandleGlobalValueChange({ name, value })
        }
    }

    handleApprovalOrderFlagValue = (e, index) => {
        let { HandleGlobalValueChange, approvalOrderFlagValue } = this.props;
        let { approvalOrderFlagError } = this.state;
        let { name, value } = e.target;
        if (!this.state.isChangeMade) {
            this.setState({ isChangeMade: true })
        }
        if (value && value.trim()) {
            if (approvalOrderFlagError && approvalOrderFlagError[index]) {
                approvalOrderFlagError = [...approvalOrderFlagError];
                approvalOrderFlagError[index] = false
                this.setState({ approvalOrderFlagError })
            }
        }
        approvalOrderFlagValue = [...approvalOrderFlagValue];
        approvalOrderFlagValue[index] = value;
        HandleGlobalValueChange && HandleGlobalValueChange({ name, value: approvalOrderFlagValue })
    }

    handleApprovalOrderFlagBlur = (e, index) => {
        let { value } = e.target;
        let { approvalOrderFlagError } = this.state;
        value = value.trim();
        if (!value) {
            approvalOrderFlagError = [...approvalOrderFlagError];
            approvalOrderFlagError[index] = true
            this.setState({ approvalOrderFlagError })
        } else if (approvalOrderFlagError[index]) {
            approvalOrderFlagError = [...approvalOrderFlagError];
            approvalOrderFlagError[index] = false
            this.setState({ approvalOrderFlagError })
        }
    }

    handleApprovalPrescriberFlagValue = (e, index) => {
        let { HandleGlobalValueChange, approvalPrescriberFlagValue } = this.props;
        let { approvalPrescriberFlagError } = this.state;
        let { name, value } = e.target;
        approvalPrescriberFlagValue = [...approvalPrescriberFlagValue];
        approvalPrescriberFlagValue[index] = value;
        if (!this.state.isChangeMade) {
            this.setState({ isChangeMade: true })
        }
        if (value && value.trim()) {
            if (approvalPrescriberFlagError && approvalPrescriberFlagError[index]) {
                approvalPrescriberFlagError = [...approvalPrescriberFlagError];
                approvalPrescriberFlagError[index] = false
                this.setState({ approvalPrescriberFlagError })
            }
        }
        HandleGlobalValueChange && HandleGlobalValueChange({ name, value: approvalPrescriberFlagValue })
    }

    handleApprovalPrescriberFlagBlur = (e, index) => {
        let { value } = e.target;
        let { approvalPrescriberFlagError } = this.state;
        value = value.trim();
        if (!value) {
            approvalPrescriberFlagError = [...approvalPrescriberFlagError];
            approvalPrescriberFlagError[index] = true
            this.setState({ approvalPrescriberFlagError })
        } else if (approvalPrescriberFlagError[index]) {
            approvalPrescriberFlagError = [...approvalPrescriberFlagError];
            approvalPrescriberFlagError[index] = false
            this.setState({ approvalPrescriberFlagError })
        }
    }

    getFlags = (data = {}) => {
        let { classes, approvalOrderFlagValue, approvalPrescriberFlagValue } = this.props;
        let { OrderFlags = [], PrescriberFlags = [] } = data, valueToReturn = [];
        for (let i = 0; i < OrderFlags.length; i++) {
            valueToReturn.push(
                <div key={i + "orderFlag"} className={classes.flagWrapper}>
                    <div id={`approve-and-email-flag-${i}`} className={classes.flagText}>{OrderFlags[i]}</div>
                    <textarea
                        id={`approve-and-email-flag-text-${i}`}
                        maxLength={4000}
                        name={"approvalOrderFlagValue"}
                        onBlur={_ => this.handleApprovalOrderFlagBlur(_, i)}
                        value={approvalOrderFlagValue[i]}
                        onChange={_ => this.handleApprovalOrderFlagValue(_, i)}
                        className={`${classes.flagTextArea} ${this.state.approvalOrderFlagError[i] ? classes.flagTextAreaError : ""}`}
                    />
                </div>
            )
        }
        for (let i = 0; i < PrescriberFlags.length; i++) {
            valueToReturn.push(
                <div key={i + "prescriberFlag"} className={classes.flagWrapper}>
                    <div className={`${classes.flagText} ${classes.noTextMargin}`}>{PrescriberFlags[i].PrescriberFlagText}</div>
                    <div className={`${classes.flagText} ${classes.noTextMargin}`}>{PrescriberFlags[i].FlaggedQuestion}</div>
                    <div className={classes.flagText}>{PrescriberFlags[i].FlaggedAnswer}</div>
                    <textarea
                        maxLength={4000}
                        name={"approvalPrescriberFlagValue"}
                        onBlur={_ => this.handleApprovalPrescriberFlagBlur(_, i)}
                        value={approvalPrescriberFlagValue[i]}
                        onChange={_ => this.handleApprovalPrescriberFlagValue(_, i)}
                        className={`${classes.flagTextArea} ${this.state.approvalPrescriberFlagError[i] ? classes.flagTextAreaError : ""}`}
                    />
                </div>
            )
        }
        return valueToReturn;
    }

    checkIfDisabled = () => {
        let {
            approvalOrderFlagValue = [],
            approvalPrescriberFlagValue = [],
            approveAndMailData = [],
            subjectLine = "",
            emailMessage = "",
            approveAndMailPin = "",
            orderAndPrescriberFlag = {},
            productInfo = {},
            formField = {},
        } = this.props;
        approveAndMailPin += "";

        if (this.state.pdfGenerationInProgress) {
            return true;
        }

        const { template: templateName } = this.isProvidersAndCreatePDFTemplateAvailable(productInfo);
        const requiredFormFieldsInEversense = [
            {
                name: 'icd10Diagnosis',
                value: formField.icd10Diagnosis.trim()
            },
            {
                name: 'checkbox-hhu',
                value: formField['checkbox-hhu']
            },
            {
                name: 'checkbox-icgm',
                value: formField['checkbox-icgm']
            },
            {
                name: 'checkbox-lticgm',
                value: formField['checkbox-lticgm']
            },
            {
                name: 'checkbox-faitr',
                value: formField['checkbox-faitr']
            },
            {
                name: 'checkbox-moti',
                value: formField['checkbox-moti']
            }
        ];
        const emptyFieldFoundInEversense = requiredFormFieldsInEversense.find((field) => field.value === '');
        if (templateName === Eversesnse && emptyFieldFoundInEversense) {
            return true;
        }

        // adds axena template validation here...
        const requiredFormFieldsInAxena = [
            {
                name: 'otherICD10Code',
                value: formField.otherICD10Code.trim()
            }
        ];
        const emptyFieldFoundInAxena = requiredFormFieldsInAxena.find((field) => field.value === '');
        if (templateName === Axena && emptyFieldFoundInAxena) {
            return true;
        }

        // adds dexcom template validation here...
        const requiredFormFieldsInDexcom = [
            {
                name: 'otherICD10Code',
                value: formField.otherICD10Code.trim()
            }
        ];
        const emptyFieldFoundInDexcom = requiredFormFieldsInDexcom.find((field) => field.value === '');
        if (templateName === Dexcom && emptyFieldFoundInDexcom) {
            return true;
        }

        // adds apretude template validation here...
        const requiredFormFieldsInApretude = [
            {
                name: 'icd10Diagnosis',
                value: formField.icd10Diagnosis.trim()
            }
        ];
        const emptyFieldFoundInApretude = requiredFormFieldsInApretude.find((field) => field.value === '');
        if (templateName === Apretude && emptyFieldFoundInApretude) {
            return true;
        }

        /**
         * @description Vyepti template validation here...
         */
        const requiredFormFieldsInVyepti = [
            {
                name: 'icd10Diagnosis',
                value: formField.icd10Diagnosis.trim()
            }
        ];
        const emptyFieldFoundInVyepti = requiredFormFieldsInVyepti.find((field) => field.value === '');
        if (templateName === Vyepti && emptyFieldFoundInVyepti) {
            return true;
        }
        // Vyepti template validation ends here

        let { OrderFlags = [], PrescriberFlags = [] } = orderAndPrescriberFlag;
        if (approvalOrderFlagValue.length !== OrderFlags.length) {
            return true;
        }
        if (approvalPrescriberFlagValue.length !== PrescriberFlags.length) {
            return true;
        }
        for (let i = 0; i < approvalOrderFlagValue.length; i++) {
            let value = approvalOrderFlagValue[i];
            if (typeof value === "string") {
                value = value.trim()
            }
            if (!value) {
                return true;
            }
        }
        for (let i = 0; i < approvalPrescriberFlagValue.length; i++) {
            let value = approvalPrescriberFlagValue[i];
            if (typeof value === "string") {
                value = value.trim()
            }
            if (!value) {
                return true;
            }
        }
        for (let i = 0; i < approveAndMailData.length; i++) {
            let { Sig = "", Note = "", DaysSupply = "", IsAlternateRx } = approveAndMailData[i];
            if (!IsAlternateRx) {
                if (typeof Sig === "string") {
                    Sig = Sig.trim()
                }
                if (typeof Note === "string") {
                    Note = Note.trim()
                }
                if (typeof DaysSupply === "string") {
                    DaysSupply = DaysSupply.trim()
                }
                if (!Sig || !Note || !DaysSupply) {
                    return true;
                }
            } else {
                if (typeof Note === "string") {
                    Note = Note.trim()
                }
                if (!Note) {
                    return true;
                }
            }
        }
        if (typeof subjectLine === "string") {
            subjectLine = subjectLine.trim();
        }
        if (typeof emailMessage === "string") {
            emailMessage = emailMessage.trim();
        }
        if (typeof approveAndMailPin === "string") {
            approveAndMailPin = approveAndMailPin.trim();
        }
        if (!subjectLine || !emailMessage || !approveAndMailPin || approveAndMailPin.length < 4) {
            return true
        }
    }

    /**
     * @todo alternateRx check should check the application settings
     * @returns {boolean}
     */
    isConfiguredAlternateRx({
        pId,
        isAlternateRx,
        skipCheckingChangeProducts,
        skipCheckingAppSettings,
    }) {
        if (isAlternateRx) {
            return true;
        }

        if (pId === ALTERNATE_RX_PRODUCT_VALUE) {
            return true;
        }

        const { productList, productInfo } = this.props;

        if (skipCheckingChangeProducts === false) {
            const { ProductItem } = productList;
            /**
             * @type {{
             *  Value: number,
             * }[]}
             */
            const changeProducts = ProductItem || [];
            /**
             * @type {boolean}
             */
            const hasAlternateRxProduct = changeProducts.some((product = {}) => {
                return product.Value === ALTERNATE_RX_PRODUCT_VALUE;
            });
            if (hasAlternateRxProduct) {
                return hasAlternateRxProduct;
            }
        }

        if (skipCheckingAppSettings === false) {
            /**
             * @type {Map<string, {
             *    key: string,
             *    value: string,
             *  }>}
             */
            const settingsCollection = new Map(productInfo?.StoreFrontData?.StorefrontApplicationSettings);
            const hasAppSetting = settingsCollection.has('AlternateRxId');
            if (hasAppSetting) {
                /**
                  * @type {{
                  *  key: string;
                  *  value: string;
                  * }}
                  */
                const setting = settingsCollection.get('AlternateRxId');
                const hasAlternateRxProduct = Number(setting.value) === ALTERNATE_RX_PRODUCT_VALUE;

                if (hasAlternateRxProduct) {
                    return hasAlternateRxProduct;
                }
            }
        }

        return false;
    }

    genrateData = (orderAndPrescriberFlag, approveAndMailData) => {
        let PrescriptionData = [], orderFlagsData = [], prescriberFlagData = [];
        let hasAlternateRx = false;
        let {
            approvalOrderFlagValue,
            approvalPrescriberFlagValue
        } = this.props;
        let { OrderFlags = [], PrescriberFlags = [] } = orderAndPrescriberFlag;
        for (let i = 0; i < approveAndMailData.length; i++) {
            let {
                ProductId,
                PharmacyId,
                DaysSupply,
                Qty,
                TotalPills,
                Refills: { DefaultOption } = {},
                Sig,
                NotePrefix,
                Note,
                orgSig,
                ProductIdForKit,
                IsAlternateRx
            } = approveAndMailData[i];

            const isRX = this.isConfiguredAlternateRx({
                pId: ProductId,
                isAlternateRx: IsAlternateRx,
                skipCheckingChangeProducts: true,
                skipCheckingAppSettings: true,
            });

            if (isRX) {
                hasAlternateRx = true;
                PrescriptionData.push({ ProductId, PharmacyId, DaysSupply, NotePrefix, Note, QTY: Qty, TotalPills, Refills: DefaultOption, Sig, SigUpdated: false, PrescriptionNote: Note, ProductIdForKit })
            }
            else {
                PrescriptionData.push({ ProductId, PharmacyId, DaysSupply, QTY: Qty, TotalPills, Refills: DefaultOption, Sig, SigUpdated: orgSig !== Sig, NotePrefix, PrescriptionNote: Note, ProductIdForKit })
            }
        }

        for (let i = 0; i < OrderFlags.length; i++) {
            orderFlagsData.push({ FlagText: OrderFlags[i], FlagResponse: approvalOrderFlagValue[i] })
        }
        for (let i = 0; i < PrescriberFlags.length; i++) {
            prescriberFlagData.push({ FlaggedQuestion: PrescriberFlags[i].FlaggedQuestion, FlaggedAnswer: PrescriberFlags[i].FlaggedAnswer, PrescriberFlagResponse: approvalPrescriberFlagValue[i] })
        }
        return { PrescriptionData, orderFlagsData, prescriberFlagData, isRX: hasAlternateRx };
    }

    onApproveAndMailClick = async (e) => {
        e.preventDefault();   
        let {
            OnApproveAndMailClick = () => {},
            approveAndMailPin,
            approveAndMailData = [],
            subjectLine,
            emailMessage,
            orderAndPrescriberFlag = {},
            handleRouteChange,
            routePath,
            callStarted,
            productInfo = {},
            selectedCardData = {}
        } = this.props;
        let { PrescriptionData = [], orderFlagsData = [], prescriberFlagData = [], isRX = false } = this.genrateData(orderAndPrescriberFlag, approveAndMailData), data = {};
        data.PrescriptionData = PrescriptionData;
        data.OrderId = productInfo.OrderId;
        data.PatientId = selectedCardData.UserId;
        data.EmailSubject = subjectLine;
        data.EmailMessage = convertIntoEmail(emailMessage);
        data.PIN = approveAndMailPin;
        data.DoctorId = selectedCardData.DoctorId;
        data.OrderFlags = orderFlagsData;
        data.PrescriberFlags = prescriberFlagData;
        data.EmailTemplates = [];

        const { template: tN, preparePDF, fileName, imageQuality, pageOptions } = this.isProvidersAndCreatePDFTemplateAvailable(productInfo);
        if (tN) {
            this.setState({ pdfGenerationInProgress: true });
            const pdf = await preparePDF(
                fileName,
                [pageSelector, pageWithMaxPossibleWidthSelector],
                pageOptions,
                pageElementSelector,
                imageQuality,
                generatePDF
            );
            data.cmn_base64_pdf = pdf;
            this.setState({ pdfGenerationInProgress: false });
        }

        if (SubmitButtonRef && SubmitButtonRef.current) {
            SubmitButtonRef.current.blur && SubmitButtonRef.current.blur();
        }
        OnApproveAndMailClick({ PIN: approveAndMailPin, approvedata: data, handleRouteChange, routePath, callStarted, DoctorId: selectedCardData.DoctorId, IsAlternateRx: isRX });
    }

    onApproveAndMailComplete = () => {
        let {
            ApproveAndMailSubmit = () => {},
            approveAndMailPin,
            approveAndMailData = [],
            subjectLine,
            emailMessage,
            orderAndPrescriberFlag = {},
            handleRouteChange,
            routePath,
            callStarted
        } = this.props;
        let { PrescriptionData = [], orderFlagsData = [], prescriberFlagData = [] } = this.genrateData(orderAndPrescriberFlag, approveAndMailData), data = {};
        let { productInfo = {}, selectedCardData = {} } = this.props;
        data.PrescriptionData = PrescriptionData;
        data.OrderId = productInfo.OrderId;
        data.PatientId = selectedCardData.UserId;
        data.EmailSubject = subjectLine;
        data.EmailMessage = convertIntoEmail(emailMessage);
        data.PIN = approveAndMailPin;
        data.OrderFlags = orderFlagsData;
        data.PrescriberFlags = prescriberFlagData;
        data.EmailTemplates = [];
        ApproveAndMailSubmit(data, handleRouteChange, routePath, callStarted);
    }

    onKeyDown = (e) => {
        if (e.keyCode === 13) {
            e.preventDefault();
        }
    }

    iframe = (url) => {
        return {
            __html: `<iframe src=${url} style="border:0px;overflow:auto;display:flex;flex:1"></iframe>`
        }
    }

    isDoseSpotModal = () => {
        return (this.props.doseSpotData && this.props.doseSpotData.openCommonModal)
    }

    isProvidersAndCreatePDFTemplateAvailable = (productInfo) => {
        if(!productInfo.pdfInfo.template) {
            return { template: null, ...ITEMPLATE({}) };
        }

        if(!ProvidersAndCreatePDFTemplateMap.has(productInfo.pdfInfo.template)) {
            return { template: null, ...ITEMPLATE({}) };
        }

        const TemplateMap = ProvidersAndCreatePDFTemplateMap.get(productInfo.pdfInfo.template);
        if (!TemplateMap.enabled) {
            return { template: null, ...ITEMPLATE({}) };
        }

        if (TemplateMap.hasPIDDependency && !productInfo.pdfInfo.productId) {
            return { template: null, ...ITEMPLATE({}) };
        }

        return { template: productInfo.pdfInfo.template, ...TemplateMap };
    };

    renderProvidersAndCreatePDFTemplate = (productInfo) => {
        const { getCmnPdfData, patientInfo, consultInfo, formField, setFormField, notes, history } = this.props;
        const { template: tN, Template, id } = this.isProvidersAndCreatePDFTemplateAvailable(productInfo);
        if (!tN) { return null; }

        return (
            <Template
                id={id}
                getCmnPdfData={getCmnPdfData}
                productInfo={productInfo}
                patientInfo={patientInfo}
                consultInfo={consultInfo}
                formField={formField}
                setFormField={setFormField}
                notes={notes}
                history={history}
            />
        );
    }

    render() {
        let {
            openapproveAndSendEmail,
            classes,
            approveAndMailData = [],
            emailTemplateValue,
            emailTemplatesV2,
            emailTemplate = [],
            subjectLine,
            emailMessage,
            approveAndMailPin,
            orderAndPrescriberFlag = {},
            approvalPinError,
            isModalAlertOpen,
            SetModalAlertOpen,
            doseSpotData = {},
            productInfo
        } = this.props;

        const emailTemplatesFromSF = generateEmailTemplateList(emailTemplatesV2, selectedProductIds(productInfo));
        const EmailTemplateCollection = new Map([
            [true, emailTemplatesFromSF],
            [false, (emailTemplate || [])],
        ]);

        let { StringValue } = doseSpotData;
        let expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
        let regex = new RegExp(expression);
        let isValidUrl = regex.test(StringValue);
        return (
            <CommonModalV2
                title={this.isDoseSpotModal() ? "DoseSpot Jumpstart" : "Approve and Send Email"}
                open={openapproveAndSendEmail}
                style={
                    this.isDoseSpotModal()
                        ? { minWidth: modalWidth.m, width: getModalWidth(), minHeight: getModalMinHeight() }
                        : { minWidth: modalWidth.m, width: getModalWidth(), maxWidth: modalWidth.xl + 32 }
                }
            >
                <div data-view="approve-and-send-email-component-wrapper"
                    onScroll={e => {
                        var isScrollingDown = e.nativeEvent.wheelDelta || -e.nativeEvent.detail;
                        e.currentTarget.scrollTop += (isScrollingDown < 0 ? 1 : -1) * 30
                        e.preventDefault();
                    }} className={classes.modalBodyWrapper}>
                    {this.isDoseSpotModal() ?
                        <Fragment>
                            {isValidUrl ? <div className={classes.doseSpotModalBody}>
                                <div className={classes.headerSection}>
                                    <div className={classes.blueText}>Please Complete the Following Steps to Approve and Send a New Prescription:</div>
                                    <div className={classes.orangeText}>{"1. Add a Prescription"}</div>
                                    <div className={classes.orangeText}>{"2. Confirm the patient's pharmacy of choice"}</div>
                                    <div className={classes.orangeText}>{`3. Select the "Approve and Send" in Pending Medications before exiting`}</div>
                                </div>
                                <div className={classes.doseSpotIframeStyle} dangerouslySetInnerHTML={this.iframe(StringValue)} />
                            </div> :
                                <div className={classes.doseSpotModalBody} >{StringValue}</div>}
                            <div className={classes.doseSpotModalActionWrapper}>
                                <Button
                                    disabled={this.checkIfDisabled()}
                                    ref={SubmitButtonRef}
                                    id="complete-and-exit"
                                    onClick={this.onApproveAndMailComplete}
                                    variant="contained"
                                    color="primary"
                                    className={classes.doseSpotButtonStyle}>
                                    Complete and Exit
                                </Button>
                                <Button
                                    id="cancel-jumpstart-button"
                                    onClick={this.openAlertModal}
                                    variant="outlined"
                                    color="primary"
                                    className={classes.cancelButtonStyle}>
                                    Close
                                </Button>
                            </div>
                        </Fragment>
                        : <Fragment>
                            <div className={classes.modalBody}>
                                {
                                    this.renderProvidersAndCreatePDFTemplate(productInfo)
                                }
                                {
                                    this.getPrescriberInfo(approveAndMailData)
                                }
                                <div className={`${classes.contentEmailWrapper} ${classes.emailTemplateMarginTop}`}>
                                    <div id="approve-and-email-email-template" className={classes.mainTitleText}>EMAIL TEMPLATES:</div>
                                    <FormControl variant="outlined" className={classes.templateInput}>
                                        <Select
                                            labelId="customized-select-label"
                                            id="approve-emailTemplateValue"
                                            MenuProps={{ classes: { paper: classes.menuItemWidth, list: classes.menuItemList } }}
                                            classes={{ outlined: classes.productSelectStyle }}
                                            value={emailTemplateValue}
                                            name={"emailTemplateValue"}
                                            onChange={this.handleEmailTemplateChange}
                                            label={void 0}
                                        >
                                            <MenuItem
                                                title={"-- Choose --"}
                                                classes={{ selected: classes.menuItemSelected }}
                                                className={classes.menuItemRoot}
                                                value={-1}>
                                                -- Choose --
                                </MenuItem>
                                            {EmailTemplateCollection.get(hasFeature.PULL_EMAIL_TEMPLATES_FROM_SALESFORCE).map((_, index) => {
                                                return <MenuItem
                                                    title={_.EmailTemplateTitle}
                                                    id={_.EmailTemplateTitle}
                                                    classes={{ selected: classes.menuItemSelected }}
                                                    className={classes.menuItemRoot}
                                                    key={index + _.EmailMessageId}
                                                    value={_.EmailMessageId}>
                                                    {_.EmailTemplateTitle}
                                                </MenuItem>
                                            })}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className={classes.contentEmailWrapper}>
                                    <div id="approve-and-email-subject-line" className={classes.mainTitleText}>SUBJECT LINE:</div>
                                    <textarea wrap="soft"
                                        onKeyDown={this.onKeyDown}
                                        maxLength={255}
                                        id="approve-subjectLine"
                                        name={"subjectLine"}
                                        value={subjectLine}
                                        onBlur={this.handleInputLineBlur}
                                        onChange={this.handleInputLineChange}
                                        type="text"
                                        className={`${this.state.subjectLineError ? classes.subjectInputError : classes.subjectInput} subjectInput`}
                                    />
                                </div>
                                <div className={classes.contentWrapperNoAlign}>
                                    <div id="approve-and-email-email-message" className={classes.titleTextEmail}>EMAIL MESSAGE:</div>
                                    <textarea
                                        maxLength={65535}
                                        id="approve-emailMessage"
                                        spellCheck={true}
                                        name={"emailMessage"}
                                        onBlur={this.handleInputLineBlur}
                                        value={emailMessage}
                                        onChange={this.handleInputLineChange}
                                        className={this.state.emailMessageError ? classes.textAreaError : classes.textArea}
                                    />
                                </div>
                                {this.getFlags(orderAndPrescriberFlag)}
                            </div>
                            <div className={classes.modalActionWrapper}>
                                <div className={classes.pinWrapper}>
                                    {approvalPinError ? <div id="approve-and-email-pin-error" className={classes.approvalPinError}>{approvalPinError}</div> : null}
                                    <div id="approve-and-email-pin" className={classes.pinStyle}>4-DIGIT PIN:</div>
                                    <input
                                        name="approveAndMailPin"
                                        type="password"
                                        id="approve-approveAndMailPin"
                                        onBlur={this.onPinBlur}
                                        onChange={this.onValueChange}
                                        maxLength={4}
                                        className={`${classes.pinTextInput} 
                                ${this.state.approveAndMailPinError ? classes.errorTextField : ""}`}
                                        value={approveAndMailPin}
                                    />
                                </div>
                                <div className="flex align-items-center gap-16">
                                    <PPButton
                                        disabled={this.checkIfDisabled()}
                                        loading={this.state.pdfGenerationInProgress}
                                        ref={SubmitButtonRef}
                                        id="approve-and-send-button"
                                        onClick={this.onApproveAndMailClick}
                                        variant="contained"
                                        label="Approve & Send Email"
                                    />
                                    <Button
                                        id="approve-and-send-cancel-button"
                                        onClick={this.openAlertModal}
                                        variant="contained"
                                        color="primary"
                                        className={classes.cancelButtonStyle}>
                                        Cancel
                                    </Button>
                                </div>
                            </div>
                        </Fragment>}
                    <ModalExitAlert
                        type="confirmation"
                        onConfirmation={this.onConfirmation}
                        modalOpen={this.state.isChangeMade && this.state.exitModalOpen}
                        closeModal={this.closeAlertModal}
                        typos={
                            this.isDoseSpotModal()
                                ? {
                                    confirmationMessage: 'Are you sure you want to close? All inputs will be lost.',
                                    confirmButtonLabel: 'Yes, close',
                                    closeButtonLabel: 'No, do not'
                                }
                                : undefined
                        }
                    />
                    <ModalExitAlert type="alert" modalOpen={isModalAlertOpen} closeModal={() => SetModalAlertOpen(false)} />
                </div>
            </CommonModalV2>
        )
    }
}


export default withStyles(ApproveAndSendEmailStyle)(ApproveAndSendEmail);

